import { FunctionComponent } from 'react';
import { AuthenticationIsLoading } from 'src/services/auth/components/AuthenticationIsLoading';
import { useClickstreamAnalytics } from 'src/analytics/hooks/useClickstreamAnalytics';
import { useMigrateToZillowState } from './hooks/useMigrateToZillowState';

export const WiredMigrateToZillow: FunctionComponent = () => {
    const triggerAnalytics = useClickstreamAnalytics();
    useMigrateToZillowState();
    triggerAnalytics();
    return <AuthenticationIsLoading />;
};
